import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import Image from '../../components/ContentfulImage';
import Placeholder from '../../components/Placeholder';
import Markdown from '../../components/Markdown';
import media from '../../styles/media.style';
import { SCREEN_LOCKUP_WIDTH, MOBILE_PADDING } from '../../styles/variables.style';

const Wrapper = styled.section`
  margin: auto;
  max-width: ${SCREEN_LOCKUP_WIDTH}px;
  padding: 20px ${MOBILE_PADDING}px;
  width: 100%;

  ${media.tabletL`
    max-width: ${SCREEN_LOCKUP_WIDTH + MOBILE_PADDING * 2}px;
    padding: 40px ${MOBILE_PADDING}px;
  `};
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.9px;
  margin: 0 auto 50px;
  position: relative;
  text-align: center;

  ${media.tabletL`
    font-size: 18px;
    letter-spacing: 0.7px;
    margin: 0 auto 85px;
  `};

  &::after {
    background-color: black;
    bottom: -25px;
    content: '';
    height: 2px;
    left: calc(50% - 20px);
    position: absolute;
    width: 40px;
  }
`;

const Stylist = styled.div`
  margin-top: 40px;
  width: 100%;

  &:first-child {
    margin-top: 0;
  }

  ${media.tabletL`
    display: flex;
    justify-content: space-between;
    margin-top: 100px;
  `};
`;

const ImageContainer = styled.div`
  width: 100%;

  ${media.tabletL`
    max-width: 50%;
  `};
`;

const Details = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  margin-top: 25px;

  ${media.tabletL`
    margin-top: 0;
    max-width: 45%;
  `};
`;

const Name = styled.div`
  font-size: 28px;
  font-weight: 500;
  line-height: 1.21;
  letter-spacing: 0.5px;

  ${media.tabletL`
    font-size: 38px;
  `};
`;

const Description = styled.div`
  font-size: 14px;
  line-height: 1.39;
  letter-spacing: 0.1px;
  margin-top: 15px;

  ${media.tabletL`
    font-size: 18px;
    margin-top: 30px;
  `};
`;

const StylistsOverview = ({ title, stylists }) => (
  <Wrapper>
    <Title>{title || <Placeholder w="100px" h="20px" />}</Title>

    {stylists.map(stylist => (
      <Stylist key={stylist.name || stylist.key}>
        <ImageContainer>
          {stylist.image ? <Image src={stylist.image} /> : <Placeholder w="100%" pb="calc(100% * 2 / 3)" />}
        </ImageContainer>

        <Details>
          <Name>{stylist.name || <Placeholder w="300px" h="45px" />}</Name>
          {stylist.description && stylist.description !== '' ? (
            <Markdown src={stylist.description} Component={Description} />
          ) : null}
        </Details>
      </Stylist>
    ))}
  </Wrapper>
);

StylistsOverview.defaultProps = {
  title: undefined,
};

StylistsOverview.propTypes = {
  title: PropTypes.string,
  stylists: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default StylistsOverview;



// WEBPACK FOOTER //
// ./src/pages/EditorialPage/StylistsOverview.js